import { useState } from 'react';
import SharedMobileHeader from 'shared/components/layout/mobile-header';
import Android from 'assets/images/android.png';
import AppDownloadsApiService from 'core/api/app-downloads/app-downloads-api-service';
import SharedButton from 'shared/components/buttons/button';

const AppDownload = () => {
  const [androidDownloading, setAndroidDownloading] = useState(false);

  const downloadAndroid = async () => {
    setAndroidDownloading(true);
    const downloadUrl = await AppDownloadsApiService.getAndroidAppDownloadUrl();
    const downloadLink = document.createElement('a');
    downloadLink.href = downloadUrl;
    downloadLink.download = `dhive-driver-android.apk`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setAndroidDownloading(false);
  };

  return (
    <div className='bg-primary'>
      <SharedMobileHeader backButton />
      <div className='bg-white rounded-t-2xl'>
        <div className='px-4 py-6 border-b'>
          <p className='headline-04'>App download</p>
        </div>
        <div className='w-full border-b p-4 flex justify-between items-center'>
          <div className='flex space-x-4'>
            <img src={Android} alt='android' className='h-6' />
            <p className='font-semibold'>Android</p>
          </div>
          <SharedButton
            type='button'
            appearance='subtle'
            label='Download'
            isLoading={androidDownloading}
            onClick={downloadAndroid}
          />
        </div>
      </div>
    </div>
  );
};

export default AppDownload;
